import React from 'react';
import PropTypes from 'prop-types';
import translate from 'react-i18next/dist/commonjs/translate';
import { currencyFormatter } from '../../../common/utils/helpers';
import Form from 'antd/lib/form';
import { 
  fetchTransactionSummaryPerAccountIdAction,
  selectPreviewTransactionsSummary,
  selectPreviewTransactionsIsLoading,
} from '../ducks';
import {
  selectAccountId,
} from '../../../features/auth/ducks';
import Spin from 'antd/lib/spin';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { 
    transactionTypes, 
} from '../../../common/enums/transactionTypes';
import { Row, Col } from 'react-flexbox-grid';

const mapStateToProps = state => ({
  accountId: selectAccountId(state),
  summary: selectPreviewTransactionsSummary(state),
  isLoading: selectPreviewTransactionsIsLoading(state),
});
  
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchTransactionSummaryPerAccountId: fetchTransactionSummaryPerAccountIdAction.request,
    },
    dispatch
  ),
});
  
@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class TransactionsSummary extends React.Component {

    static propTypes = {
        summary: PropTypes.object,
      };

    
      componentDidMount() {
        const {
          actions,
          accountId
        } = this.props;

        actions.fetchTransactionSummaryPerAccountId(accountId);
      }

    render() {
        const { 
          t, 
          summary,
          isLoading
        } = this.props;

        return <Spin spinning={isLoading} className="withdraw-funds-wrapper panel-wrapper" >
           <h2 style={{color: "#0A4892", textAlign: 'left'}}>Sumárny prehľad</h2>

          {!!summary && Object.entries(summary).map(([key, value]) => {
                return <Row between={'lg'} className="overview-row">
                        <p >{t(transactionTypes[key]||key)}</p> <p className={ key==="SUMMARY" ? "p-in-table p-in-summary" : "p-in-table"}>{currencyFormatter(value)}</p>
                       </Row>
            })
          }
        </Spin>
    }
}


// WEBPACK FOOTER //
// ./src/features/transactions/components/TransactionsSummary.js